import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import DOMPurify from "dompurify";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function renderTxt(text: string) {
  // To dynamically render text with HTML + tailwind classes
  const sanitizedText = DOMPurify.sanitize(text);
  return { __html: sanitizedText };
}

export function formatDate(dateString: string, locale?: string): string {
  const date = new Date(dateString);

  if (locale) {
    try {
      // Check if the locale is valid
      new Intl.DateTimeFormat(locale);
      return date.toLocaleDateString(locale || undefined, {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    } catch (e) {
      locale = undefined; // Fallback to default locale
    }
  }
  return date.toISOString().split("T")[0];
}
